<template>
  <div class="container">
    <div :class="{ banner: true, showBtn: btnFlage }">
      <div class="swiper-container bannerSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in bannerList"
            :key="index + 'qua'"
          >
            <img :src="item.photo" width="100%" height="auto" />
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-next"></div>
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-pagination"></div>
        <!--分页器。如果放置在swiper外面，需要自定义样式。-->
      </div>
    </div>
    <div class="joinbody">
      <div class="switchTab">
        <div class="tabBody">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import { getBanner } from '@/api/apiCenter'
export default {
  data() {
    return {
      navName: '人才招聘',
      imgHeight: '800',
      bannerList: [],
      btnFlage: false,
    }
  },
  methods: {
    init() {
      let that = this
      getBanner('activity').then((res) => {
        that.bannerList = res.data.data
        this.$nextTick(() => {
          that.initBannerSwiper()
        })
        this.getNews()
      })
    },
    initBannerSwiper() {
      this.bannerSwiper = new Swiper('.bannerSwiper', {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 500,
        freeMode: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
    },
    phoneLink(name) {
      let url = '/joinus/' + name
      this.$router.push(url)
    },
    site(index, name, query) {
      let url = '/joinus/' + name
      let lis = document.querySelectorAll('.site')
      let spans = document.querySelectorAll('.siteSpan')
      this.navName = query

      for (let i = 0; i < lis.length; i++) {
        lis[i].style.borderBottom = '0 solid rgb(57,99,174)'
        spans[i].style.color = '#000000'
        spans[i].style.fontWeight = 500
      }
      spans[index].style.color = '#3963AE'
      spans[index].style.fontWeight = 600
      lis[index].style.borderBottom = '3px solid rgb(57,99,174)'
      this.$router.push(url)
    },
    initStyle(index) {
      let lis = document.querySelectorAll('.site')
      let spans = document.querySelectorAll('.siteSpan')
      let tag = index || 0

      if (this.navName === '加入我们') {
        tag = 0
      }
      for (let i = 0; i < lis.length; i++) {
        spans[i].style.color = '#000000'
        spans[i].style.fontWeight = 500
        lis[i].style.borderBottom = '0 solid rgb(57,99,174)'
      }
      spans[tag].style.color = '#3963AE'
      spans[tag].style.fontWeight = 600
      lis[tag].style.borderBottom = '3px solid rgb(57,99,174)'
    },
    getNavName(name) {
      let tagName = name || '人才招聘'
      if (tagName === '公司简介') {
        tagName = '人才招聘'
      }
      this.navName = tagName
    },
    goCenter() {
      document.body.scrollTop = 500
      document.documentElement.scrollTop = 500
      window.pageXOffset = 500
    },
    goTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      window.pageXOffset = 0
    },
  },
  mounted() {
    this.init()
    this.$EventBus.$on('goJoinCen', () => {
      this.goCenter()
    })
    this.$EventBus.$on('goJoinTop', () => {
      this.goTop()
    })
    this.$EventBus.$on('navJoinChange', (name) => {
      this.getNavName(name)
    })
    this.$EventBus.$on('initJoinStyle', (index) => {
      this.initStyle(index)
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('initJoinStyle')
    this.$EventBus.$off('navJoinChange')
    this.$EventBus.$off('goJoinTop')
    this.$EventBus.$off('goJoinCen')
  },
}
</script>

<style scoped>
/* 轮播部分 */
.banner .swiper-container {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper .swiper-slide {
  width: 100%;
  height: auto;
}
.banner .swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: rgba(161, 161, 161, 0.5); /* 单独设置按钮颜色 */
  --swiper-navigation-size: 50px; /* 设置按钮大小 */
  --swiper-pagination-color: rgba(255, 255, 255, 0.5); /* 两种都可以 */
  --swiper-pagination-size: 50px; /* 设置按钮大小 */
}

.joinus {
  width: 100%;
  height: auto;
}
.joinus .bgtitle {
  width: 240px;
  height: auto;
  position: absolute;
  left: 20%;
  top: 20%;
}
.joinus .bgtitle h1 {
  font-size: 50px;
  font-family: 'PingFangSC-Medium';
  color: #ffffff;
  margin: 0 0 30px 0;
  padding: 0;
  font-weight: 400;
}
.joinus .bgtitle span {
  font-size: 28px;
  font-family: 'Arial-BoldMT';
  color: #ffffff;
}
.navcontainer {
  width: 100%;
  height: 50px;
  background-color: rgb(246, 248, 251);
}
.navcontainer .navmain {
  width: 300px;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
  left: 200px;
}
.navcontainer .navmain span {
  font-family: 'PingFang SC', 'PingFang SC-Regular';
  margin-right: 5px;
  font-size: 16px;
}
.joinbody {
  width: 100%;
  height: auto;
}
.switchTab {
  width: 100%;
  height: auto;
  position: relative;
  top: 40px;
  margin-bottom: 250px;
}
.switchTab .tabMain {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #e1e2e3;
}
.switchTab .tabMain .tabtitle {
  width: 1100px;
  height: 60px;
  margin: 0 auto;
  text-align: center;
}
.switchTab .tabBody {
  width: 70%;
  height: auto;
  position: relative;
  top: 30px;
  margin: 0 auto;
}
.switchTab .tabMain ul {
  margin: 0;
  padding: 0;
}
.switchTab .tabMain ul li {
  list-style: none;
  display: inline-block;
  width: 200px;
  height: 60px;
  text-align: center;
  border-bottom: 0 solid rgb(57, 99, 174);
  cursor: pointer;
  margin: 0 60px;
}
.switchTab .tabMain ul li span {
  font-size: 24px;
  font-family: 'PingFang SC', 'PingFang SC-Bold';
  font-weight: 500;
  color: rgb(128, 141, 154);
}
.switchTab .tabMain ul li:hover {
  border-bottom: 3px solid rgb(57, 99, 174);
}
.phoneTab {
  width: 100%;
  display: none;
}
.phoneTabTitle {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 0.5px solid #ebeef5;
}
.phoneTabTitle span {
  font-size: 14px;
}
@media screen and (max-width: 1200px) {
  .switchTab .tabMain {
    display: none;
  }
  .phoneTab {
    display: block;
  }
  .switchTab {
    top: -4px;
  }
  .switchTab .tabBody {
    width: 90%;
  }
}
@media screen and (max-width: 996px) {
  .joinus .bgtitle {
    top: 10%;
    left: 10%;
  }
}
@media screen and (max-width: 664px) {
  .joinus .bgtitle {
    top: 12%;
    left: 12%;
  }
  .joinus .bgtitle h1 {
    font-size: 30px;
    margin: 0 0 10px 0;
  }
  .joinus .bgtitle span {
    font-size: 10px;
  }
}
</style>
<style>
.phoneTab .el-collapse-item__header span {
  font-size: 16px;
  position: relative;
  left: 2%;
}
.phoneTab .el-collapse-item__content {
  padding: 0;
}
</style>
